"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestConfig = void 0;
/**
 * Internal method to form an Axios configuration object with the base URL and auth token
 *
 * @returns {object} Axios request config object
 * @memberof ChipperSDK
 */
function getRequestConfig(defaultOptions, authToken, params) {
    return Object.assign(defaultOptions, {
        headers: Object.assign(defaultOptions.headers || {}, { Authorization: authToken }),
        params
    });
}
exports.getRequestConfig = getRequestConfig;
//# sourceMappingURL=utils.js.map